export default __webpack_public_path__ + "static/media/5.05f59c7e.png";